import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    BarElement,
    CategoryScale,
    LinearScale,
} from 'chart.js';

// Register required chart components in Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, BarElement, CategoryScale, LinearScale,);

const HorizontalGraph = () => {
    const data = {
        labels: ['Heating & AC', 'EV Charge', 'Plug Loads', 'Refrigeration', 'Lighting', 'Others'],
        datasets: [
            {
                data: [1.4, 0.9, 0.8, 0.7, 0.4, 0.2],
                backgroundColor: [
                    '#a249d6', // purple for Heating & AC
                    '#8d3bcf', // purple for EV Charge
                    '#7731c6', // purple for Plug Loads
                    '#6429bb', // purple for Refrigeration
                    '#4f1fb1', // purple for Lighting
                    '#3915a3', // purple for Others
                ],
                borderColor: '#000',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        indexAxis: 'y', // Horizontal bar chart
        scales: {
            x: {
                beginAtZero: true,
                ticks: {
                    stepSize: 0.5,
                    color: 'white', // Tick color
                },
                grid: {
                    display: false, // Remove x-axis grid lines
                },
            },
            y: {
                ticks: {
                    autoSkip: false, // Show all labels
                    color: 'white',  // Tick color for y-axis
                },
                grid: {
                    display: false, // Remove y-axis grid lines
                },
            },
        },
        maintainAspectRatio: false, // Chart is responsive
        responsive: true,
        plugins: {
            legend: {
                display: false, // Hide the legend
            },
        },
    };
    return (

        <div className='p-2' id="secondBarGraph">

            <div className="box p-2">
                {/* <canvas id="myChart33" width="596" height="726" ></canvas> */}
                <div style={{ display: 'block', boxSizing: 'border-box', height: '363px', width: '100%' }}>
                    <Bar data={data} options={options} />
                </div>
            </div>


        </div>

    )
}
export default HorizontalGraph;
